import { render } from "./DepoimentoClinica.vue?vue&type=template&id=1fedc410&scoped=true"
import script from "./DepoimentoClinica.vue?vue&type=script&lang=js"
export * from "./DepoimentoClinica.vue?vue&type=script&lang=js"

import "./DepoimentoClinica.vue?vue&type=style&index=0&id=1fedc410&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\aut_fri_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fedc410"]])

export default __exports__